<template>
  <div class="metadata-form">
    <label for="title" >Asset title*</label>
    <input name="title" type="text" v-validate="'required'" placeholder="Asset title" v-model="title" />
    <span class="invalid">{{ errors.first('title') }}</span>
    <label for="videoUrl" >From Video URL*</label>
    <input name="videoUrl" type="text" v-validate="'required'" placeholder="Video url" v-model="src" />
    <span class="invalid">{{ errors.first('videoUrl') }}</span>
    <label>Video URL from</label>
    <div class="button-div">
      <button title="Get video url from Pinwall" class="button" @click="showPinwall=!showPinwall">Pinwall</button>
      <button title="Get video url from Kaltura" class="button" @click="showKaltura=!showKaltura">Kaltura</button>
    </div>
    <pinwall v-on:inputAsset="updateSrc" v-on:close="showPinwall=false" v-if="showPinwall" :type="'video'"></pinwall>
    <kaltura v-on:inputMedia="updateSrc" v-on:close="showKaltura=false" v-if="showKaltura"></kaltura>
    <label for="file" >Or from data file</label>
    <input name="file" type="file" v-on:change="onPickFile($event)" accept=".json" />
    <collapse :name="'Language & Subtitles'">
      <label class="txt-label">Language*</label>
      <div class="language">
        <label><input type="checkbox" name="language" :id="'de'" :value="'de'" v-validate="'required'" v-model="languages"> DE</label>
        <label><input type="checkbox" :id="'fr'" :value="'fr'" v-model="languages"> FR</label>
        <label><input type="checkbox" :id="'it'" :value="'it'" v-model="languages"> IT</label>
        <label><input type="checkbox" :id="'en'" :value="'en'" v-model="languages"> EN</label>
        <label><input type="checkbox" :id="'zh'" :value="'zh'" v-model="languages"> ZH</label>
        <label><input type="checkbox" :id="'ar'" :value="'ar'" v-model="languages"> AR</label>
      </div>
      <span class="invalid">{{ errors.first('language') }}</span>
      <label>Default language</label>
      <select v-model="defaultLanguage">
        <option></option>
        <option v-for="language in languages" v-bind:key="language">{{language}}</option>
      </select>
      <div v-for="subtitle in subtitles" v-bind:key="subtitle.lang">
        <label>Subtitles {{subtitle.lang}}</label>
        <input placeholder="Subtitle src"   v-model="subtitle.file"/>
      </div>
    </collapse>
    <collapse :name="'Video controls'">
      <label for="showScrubbar" class="txt-label">Show scrubbar initially</label>
      <toggle name="showScrubbar" v-model="showScrubbar" />
      <label for="showSubtitles" class="txt-label">Show subtitles initially</label>
      <toggle name="showSubtitles" v-model="showSubtitles" />
      <label for="isAutoplay" class="txt-label">Has Autoplay</label>
      <toggle name="isAutoplay" v-model="isAutoplay" />
      <label for="isMuted" class="txt-label">Is Muted</label>
      <toggle name="isMuted" v-model="isMuted" />
    </collapse>
    <collapse :name="'Optional settings'">
      <label for="poster" >Poster Image</label>
      <input name="poster" type="text" v-validate="'url|image'" placeholder="Poster image src" v-model="poster" />
      <span class="invalid">{{ errors.first('poster') }}</span>
      <image-picker :width='1280' :height='720' :isModal="true" :showImageName="false" :image="poster" @change="setPoster"></image-picker>
      <label>Theme</label>
      <select v-model="theme">
        <option></option>
        <option v-for="theme in user.themes" v-bind:key="theme">{{theme}}</option>
      </select>
      <label for="analytics" >Analytics Type</label>
      <select @change="analytics.code=''" v-model="analytics.type">
        <option></option>
        <option value="ga">Google Analytics</option>
      </select>
      <label v-if="analytics.type !== ''" for="analyticsCode" >Analytics code</label>
      <input v-if="analytics.type !== ''" name="analyticsCode" type="text" placeholder="analytics code" v-model="analytics.code" />
      <label for="pinwall" class="txt-label">Video available on Pinwall</label>
      <toggle name="pinwall" v-model="pinwall" />
    </collapse>
    <section class="actions-section">
    <ul>
      <li v-for="error in errors.all()" class="invalid">{{ error }}</li>
    </ul>
      <span>
        <button title="Close update" class="action-button close" @click="$emit('close')">Close</button>
        <button title="Create asset" class="action-button" @click="create()">Create</button>
      </span>
    </section>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import Pinwall from '../pinwall'
import Kaltura from '../kaltura'
import Toggle from './../core/Toggle'
import ImagePicker from './../core/ImagePicker'
import Collapse from './../core/Collapse'

export default {
  name: 'add',
  components: {Pinwall, Kaltura, Toggle, ImagePicker, Collapse},
  computed: {
    ...mapGetters(['video', 'selectedAsset', 'user'])
  },
  watch: {
    'languages': 'onLanguagesChange'
  },
  data: () => ({
    title: '',
    videoTitle: '',
    theme: '',
    linkNext: '',
    showScrubbar: true,
    showSubtitles: false,
    showPinwall: false,
    showOptionalSettings: false,
    showKaltura: false,
    isMuted: false,
    isAutoplay: false,
    pinwall: false,
    poster: '',
    src: 'http://vjs.zencdn.net/v/oceans.mp4',
    start: 'Start!',
    loading: false,
    subtitles: [{lang: 'de', file: ''}],
    defaultLanguage: '',
    analytics: {
      type: '',
      code: ''
    },
    assets: [],
    content: null,
    languages: ["de"]
  }),
  methods: {
    ...mapActions(['loadData', 'createAsset']),
    ...mapMutations(['createNew', 'setMode']),
    onPickFile(event) {
      var that = this
      const input = event.target
      if (input.files && input.files[0]) {
        const reader = new FileReader()
        reader.onload = (e) => {
          try {
            let video = JSON.parse(e.target.result)
            that.src = video.src
            that.content = video
            if (video.meta.theme) {
              that.theme = video.meta.theme
            }
            if (video.meta.isMuted) {
              that.isMuted = video.meta.isMuted
            }
            if (video.meta.isAutoplay) {
              that.isAutoplay = video.meta.isAutoplay
            }
            if (video.meta.showSubtitles) {
              that.showSubtitles = video.meta.showSubtitles
            }
            if (video.meta.showScrubbar) {
              that.showScrubbar = video.meta.showScrubbar
            }
            if (video.meta.pinwall) {
              that.pinwall = video.meta.pinwall
            }
            if (video.subtitles) {
              that.subtitles = video.subtitles
            }
            if (video.meta.languages) {
              that.languages = video.meta.languages
            }
            if (video.meta.analytics) {
              that.analytics = video.meta.analytics
            }
            if (video.meta.adaptive) {
              that.adaptive = video.meta.adaptive
            }
            if (video.meta.defaultLanguage) {
              that.defaultLanguage = video.meta.defaultLanguage
            }
            if (video.meta.poster) {
              that.poster = video.meta.poster
            }
            video.assetId = ''
            video.meta.title = that.title
            that.loadData(video)
          } catch (err) {
            console.error('failed to load json data', err)
          }
        }
        reader.readAsText(input.files[0])
      }
    },
    onLanguagesChange(newValue, oldValue) {
      // if (newValue.length === 0) {
      //   this.languages.push(oldValue[0])
      //   document.getElementById(oldValue[0]).checked = true
      // }
      const actualSubtitles = this.subtitles;
      this.subtitles = []
      this.languages.map(lang =>  {
        const subtitleFound = actualSubtitles.find(subtitle => subtitle.lang === lang)
        this.subtitles.push({
          lang: lang,
          file: subtitleFound ? subtitleFound.file : ''
        })        
      })
    },
    setPoster(imageUrl) {
      this.poster = imageUrl
    },
    updateSrc(event) {
      this.src = event.url
      this.adaptive = event.adaptive ? event.adaptive : null
      this.showPinwall = false
      this.showKaltura = false
      this.subtitles = event.subtitles
      this.poster = event.poster
    },
    create: function() {
      this.$validator.validate().then(valid => {
        if (valid) {

        if (this.src.includes(".m3u8")) {
          this.adaptive = [{
            type: "hls",
            url: this.src
          }];
        }

        var that = this
        this.createNew({url: this.src, title: this.videoTitle, theme: this.theme, linkNext: this.linkNext, showScrubbar: this.showScrubbar, isAutoplay: this.isAutoplay, isMuted: this.isMuted, languages: this.languages, defaultLanguage: this.defaultLanguage, analytics: this.analytics, adaptive: this.adaptive, subtitles: this.subtitles, showSubtitles: this.showSubtitles, poster: this.poster})

        if (this.content != null) {
            this.content.title = this.videoTitle;
            this.content.src = this.src;
            this.content.meta.title = this.videoTitle;
            this.content.meta.src = this.src;
            this.content.meta.theme = this.theme;
            this.content.meta.linkNext = this.linkNext;
            this.content.meta.languages = this.languages;
            this.content.analytics = this.analytics;
        }

        const asset = { id: this.video.assetId, title: this.title, videoTitle: this.videoTitle, pinwall: this.pinwall, src: this.src, content: JSON.stringify(this.content != null ? this.content : this.video) };
        this.createAsset(asset).then(() => {
            let video = JSON.parse(that.selectedAsset.content)
            video.assetId = that.selectedAsset.id
            that.loadData(video)
            that.setMode(null)
            that.$router.push('editor')
            });
        this.$emit('close')
        }
      })
    }
  }
}
</script>
